import axios from 'axios'
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    wyslijZapytanieOLogowanie(login, pass) {
        return axios({
            method: 'POST',
            url: URL + 'dostep',
            data: (JSON.stringify({'login': login, 'pass': pass, 'fcmToken':(Boolean(localStorage.getItem('fcm-token'))?localStorage.getItem('fcm-token').substr(1,localStorage.getItem('fcm-token').length-2):null)})),
            headers: {'Authorization': 'Basic ' + btoa(login + ':' + pass), 'Content-Type': 'application/json'},

        });
    },

    zalogujUzytkownika(user, token) {
        localStorage.setItem('obecnyUserMacelApp', JSON.stringify(user))
        axios.defaults.headers.common.Authorization = token;
    },

    pobierzAutoryzację() {
        if (Boolean(localStorage.getItem('obecnyUserMacelApp')))
            return JSON.parse(localStorage.getItem('obecnyUserMacelApp')).token
        else return ''
    },

    pobierzZalogowanego() {
        if (Boolean(localStorage.getItem('obecnyUserMacelApp')))
            return JSON.parse(localStorage.getItem('obecnyUserMacelApp'))
    },

    pobierzLoginZalogowanego() {
        if (Boolean(localStorage.getItem('obecnyUserMacelApp')))
            return JSON.parse(localStorage.getItem('obecnyUserMacelApp')).login
    },

    sprawdzCzyZalogowany() {
        return Boolean(localStorage.getItem('obecnyUserMacelApp'))
    },

    sprawdzCzyToUrzad(){
      if(this.sprawdzCzyZalogowany()){
          let roleUzytkownika = JSON.parse(localStorage.getItem('obecnyUserMacelApp')).role
          return Boolean(roleUzytkownika.find(r => (r.rola == 'ROLE_URZAD')))
      }else return false
    },

    sprawdzCzyToAdmin(){
        if(this.sprawdzCzyZalogowany()){
            let roleUzytkownika = JSON.parse(localStorage.getItem('obecnyUserMacelApp')).role
            return Boolean(roleUzytkownika.find(r => (r.rola == 'ROLE_ADMIN')))
        }else return false
    },

    sprawdzCzyZalogowanyPosiadaRole(role) {

        if (this.sprawdzCzyZalogowany() && Boolean(role)) {
            let roleUzytkownika = JSON.parse(localStorage.getItem('obecnyUserMacelApp')).role
            if (roleUzytkownika.length > 0) {
                if (roleUzytkownika.find(r=>r.rola ==='ROLE_ADMIN')) {
                    return true
                }
                else {

                    let access = false;

                    role.map(rola => {
                        if (Boolean(roleUzytkownika.find(r => (r.rola == rola)))) {
                            access = true
                        }
                    })

                    return access
                }
            } else return false

        } else return false
    },

    czyPosiadaRole(role) {

        if (this.sprawdzCzyZalogowany() && Boolean(role)) {
            let roleUzytkownika = JSON.parse(localStorage.getItem('obecnyUserMacelApp')).role
            if (roleUzytkownika.length > 0) {

                let access = false;

                role.map(rola => {
                    if (Boolean(roleUzytkownika.find(r => (r.rola == rola)))) {
                        access = true
                    }
                })

                return access

            } else return false

        } else return false
    },

    wyloguj() {
        localStorage.removeItem('obecnyUserMacelApp')
    }

}



// WEBPACK FOOTER //
// ./src/modules/logowanie/LogowanieService.js